import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { StoreDeliveryFeeTemplate } from 'components/Templates'

const StoreDeliveryFee: FC = () => {
  return (
    <Layout title={'配送料設定'}>
      <StoreDeliveryFeeTemplate />
    </Layout>
  )
}

export default StoreDeliveryFee
